/* app/js/src/components/common/tot-sliding-toggle/tot-sliding-toggle.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.toggle-container {
  display: flex;
  gap: 4px;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 0;
  -webkit-user-select: none;
  user-select: none;
}
.toggle-container.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.toggle-container.disabled .toggle-input,
.toggle-container.disabled .toggle-label {
  pointer-events: none;
}
.toggle-container.disabled:hover {
  cursor: not-allowed;
}
.toggle-container span {
  color: rgba(0, 0, 0, 0.85);
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.toggle-container .toggle-switch {
  position: relative;
  width: 32px;
  height: 18px;
}
.toggle-container .toggle-switch .toggle-input {
  display: none;
}
.toggle-container .toggle-switch .toggle-label {
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 50px;
  border: rgba(0, 0, 0, 0.54) 2px solid;
  position: relative;
  align-items: center;
  padding: 0 4px;
  cursor: pointer;
}
.toggle-container .toggle-switch .toggle-ball {
  width: 11px;
  height: 11px;
  background-color: rgba(0, 0, 0, 0.54);
  border-radius: 50%;
  transition: transform 0.3s;
}
.toggle-container .toggle-switch .toggle-input:checked + .toggle-label .toggle-ball {
  transform: translateX(10px);
}
/*# sourceMappingURL=tot-sliding-toggle.component.css.map */
